import React from 'react';
import styled from 'styled-components';
import {
  themeColor,
  itvThemeColor,
  tabletMediaQuery,
  mobileMediaQuery,
} from '../../Theming';
import { isMobile } from '../../Common/Utils/platforms';
import Button from './Button';
import { getActivationButtonStatusMsg, getExtensionInstallMsg } from '../utils';
import { useTranslation } from 'react-i18next';

const gutter = 10;
const rowInlinePadding = `10rem`;
const columnInlinePadding = `6rem`;

const Container = styled.div`
  padding-top: 120px;
  flex-direction: column;
  background-color: ${itvThemeColor('gray')};
  padding-bottom: 94px;

  ${tabletMediaQuery} {
    padding-bottom: 24px;
    padding-top: 24px;
    background-color: ${themeColor('white')};
  }
`;

const MainText = styled.span`
  font-family: Arial;
  font-size: 36px;
  font-weight: bold;
  color: ${themeColor('black')};
  text-align: left;
  display: in-line;
  line-height: 130%;
  display: block;

  ${mobileMediaQuery} {
    font-size: 20px;
  }
`;

const SubText = styled.span`
  font-family: Arial;
  font-size: 20px;
  text-align: left;
  margin-top: 8px;
  line-height: 130%;
  display: block;

  ${mobileMediaQuery} {
    font-size: 16px;
  }
`;

const ImageContainer = styled.div`
  height: 254px;
  background-color: ${itvThemeColor('lightGray')};
  width: 362px;

  ${tabletMediaQuery} {
    margin-top: 24px;
    width: 100%;
  }
`;

const Row = styled.div`
  max-width: 100vw;
  margin: 0 auto;
  padding-inline: ${rowInlinePadding};

  &::after {
    content: '';
    display: table;
    clear: both;
  }

  ${tabletMediaQuery} {
    max-width: 130rem;
    padding-inline: 0px;
  }
`;

const Column = styled.div`
  float: left;
  width: calc((100% - ${gutter}px) / 2);
  padding-inline: ${columnInlinePadding};

  ${tabletMediaQuery} {
    padding-inline: 24px;
    width: 100% !important;
  }

  &:not(:last-child) {
    margin-right: 10px;

    ${tabletMediaQuery} {
      margin-right: ${gutter}px;
    }
  }

  &:nth-child(2n) {
    margin-right: 0;
  }
`;

const DesktopDownloadContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  width: 255px;
`;

const DesktopDownloadText = styled.span`
  font-size: 20px;
  font-weight: bold;
  font-family: Arial;
  line-height: 130%;
  padding-bottom: 16px;
`;

const StatusMsgContainer = styled.div`
  position: relative;
  margin-top: 27px;
  width: 70%;
`;

const StatusMsgContent = styled.div`
  display: flex;
  flex-direction: row;
  padding-block: 8px;
  background-color: ${itvThemeColor('gray')};
  border-radius: 5px;
`;

const StatusMsg = styled.span`
  display: block;
  font-family: Arial;
  font-size: 14px;
  line-height: 120%;
  padding-right: 10px;
`;

const Triangle = styled.div`
  position: absolute;
  left: 50px;
  top: -20px;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 30px solid ${itvThemeColor('gray')};
`;

const InfoIcon = styled.span`
  margin-inline: 8px;
`;

const Image = styled.img``;

interface CashSaverProps {
  mainText?: string;
  subText?: string;
  desktopDownloadText?: string;
  desktopDownloadButtonText?: string;
  installExtensionLink?: string;
  onInstallClick?: () => void;
}

const CashSaver: React.FC<CashSaverProps> = ({
  mainText,
  subText,
  desktopDownloadText,
  desktopDownloadButtonText,
  installExtensionLink,
  onInstallClick,
}) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Row>
        <Column>
          <MainText>{mainText}</MainText>
          <SubText>{subText}</SubText>

          {!isMobile() && (
            <>
              <DesktopDownloadContainer>
                <DesktopDownloadText>{desktopDownloadText}</DesktopDownloadText>
                <a href={installExtensionLink} onClick={onInstallClick}>
                  <Button
                    disabled={!installExtensionLink}
                    height="42px"
                    className="itvTheme"
                  >
                    {desktopDownloadButtonText}
                  </Button>
                </a>
              </DesktopDownloadContainer>
              {!installExtensionLink && (
                <StatusMsgContainer>
                  <Triangle />
                  <StatusMsgContent>
                    <InfoIcon>&#9432;</InfoIcon>
                    <StatusMsg>{getExtensionInstallMsg(t)}</StatusMsg>
                  </StatusMsgContent>
                </StatusMsgContainer>
              )}
            </>
          )}
        </Column>

        <Column>
          <ImageContainer>
            {/* <Image src={images.Itv_logo.default} /> */}
          </ImageContainer>
        </Column>
      </Row>
    </Container>
  );
};

export default CashSaver;
